<template>
  <div>
    <div v-if="activeComponent">
      <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
        <b-breadcrumb-item tag="a" @click.prevent="goToList()">
          {{ $t('integrations.title') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item tag="a" @click.prevent="goToGallery()">
          {{ $t('integrations.galleryTitle') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active>
          {{ templateLabel }}
        </b-breadcrumb-item>
      </b-breadcrumb>

      <component :is="activeComponent" @saved="goToList" />
    </div>
    <div v-else class="has-text-centered">
      <p class="is-size-4">{{ $t('integrations.notFound') }}</p>
      <b-button @click="goToGallery()" class="mt-4">
        {{ $t('global.back') }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useIntegrationTemplates } from '@/utils/integrationTemplates'

export default defineComponent({
  name: 'IntegrationCreate',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { getTemplateLabel, getTemplateComponent } = useIntegrationTemplates()
    
    const template = computed(() => route.params.template as string)
    const templateLabel = computed(() => getTemplateLabel(template.value))
    const activeComponent = computed(() => getTemplateComponent(template.value))

    const goToList = () => router.push({ name: 'integration-list' })
    const goToGallery = () => router.push({ name: 'integration-gallery' })

    return { templateLabel, activeComponent, goToList, goToGallery }
  }
})
</script>


